import React, { useState } from "react";
import Helmet from "react-helmet";
import { Link, Redirect } from "react-router-dom";

import Wrapper from "../Styles/wrapper";

import Grid, { Title } from "../Styles/grid";

import Config from "../Config/hexProfile.json";

const hexChooser = ({ match, location }) => {
  const { params: part } = match;
  const bitSplit = part.bit.split("-");
  const cata = bitSplit[1];

  const [profile] = useState(cata);

  const leng = part.leng;
  const str = leng.substring(0, leng.length - 2);

  let awesome = null;
  for (const i in Config) {
    for (const l in Config[i].Types) {
      const bbb = Config[i].Name;
      const aaa = Config[i].Types[l].Size;
      if (bbb === cata && aaa === str) {
        awesome = Config[i].Types[l].Type;
      }
    }
  }

  return (
    <>
      {profile === "inch" ? (
        <Wrapper>
          <Helmet>
            <title>Hex Inch | Wiha BitFinder</title>
          </Helmet>
          <h2>Hex Profile</h2>
          <Grid fifths>
            {awesome &&
              awesome.map(aaa => {
                return (
                  <Link to={`${aaa.profile}in/`} key={aaa.profile}>
                    <button>
                      <Title>{aaa.profile.replace(/\+/gi, "/")}</Title>
                    </button>
                  </Link>
                );
              })}
          </Grid>
        </Wrapper>
      ) : profile === "metric" ? (
        <Wrapper>
          <Helmet>
            <title>Hex Metric | Wiha BitFinder</title>
          </Helmet>
          <h2>Hex Profile</h2>
          <Grid fifths>
            {awesome &&
              awesome.map(aaa => {
                return (
                  <Link to={`${aaa.profile}mm/`} key={aaa.profile}>
                    <button>
                      <Title>{aaa.profile.replace(/\+/gi, "/")}</Title>
                    </button>
                  </Link>
                );
              })}
          </Grid>
        </Wrapper>
      ) : (
        <Redirect push to={`x/`} />
      )}
    </>
  );
};

export default hexChooser;
